import { get, post, put, destroy } from "presentation/utils/api";

//Define a rota base desse serviço
const baseRoute = "Addresses";


export const findAll = async () => {
    return await get(baseRoute);
};

export const findById = async (id) => {
    return await get(baseRoute, "/" + id);
};

export const searchExternal = async (zipCode) => {
    return await get(baseRoute, "/common_data/search", { zipCode: zipCode });
};

export const add = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "", data);
};

export const update = async (postData) => {
    var data = JSON.stringify(postData);
    return await put(baseRoute, "", data);
};

export const save = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "save", data);
};

export const remove = async (id) => {
    return await destroy(baseRoute, "", id);
};

export const search = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "search", data);
};


const addressesService = {
    findAll,
    findById,
    add,
    update,
    save,
    remove,
    search,
    searchExternal
}

export default addressesService;